<template>
  <b-modal
    ref="modal"
    id="modal-venda-cadastro-boleto"
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    size="lg"
  >
    <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
      <div class="header-icon-wrapper mr-3 bg-white-10">
        <i class="fa fa-barcode text-white"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Gerar Titulo Bancario (Boleto)</h5>
        <small class="text-white opacity-75">Configuracao de conta e emissao de cobranca</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fechar()">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <div class="p-4 bg-white">
      <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
        <b-row align-v="center">
          <b-col md="8">
            <small class="modal-label-premium">Cliente Pagador</small>
            <h5 class="mb-0 font-weight-bold text-dark">{{ boleto.clienteId }} - {{ boleto.nomeCliente }}</h5>
            <small class="text-muted font-weight-bold">Titulo: {{ boleto.documento }} / {{ boleto.parcela }}</small>
          </b-col>
          <b-col md="3" class="border-left text-right">
            <small class="modal-label-premium text-right">Valor Total</small>
            <h5 class="mb-0 font-weight-bold text-success">{{ formatCurrency(boleto.valorDocumento) }}</h5>
          </b-col>
        </b-row>
      </div>

      <div class="modal-section-title mb-3">
        <i class="fa fa-university mr-2 text-primary"></i> Configuracoes de Recebimento
      </div>

      <div class="p-4 bg-light rounded border shadow-xs mb-4">
        <b-row class="mb-3">
          <b-col md="12">
            <label class="modal-label-premium">Empresa Emitente</label>
            <b-form-select
              v-model="boleto.empresaId"
              :options="empresas.options"
              :state="!!boleto.empresaId"
              class="rounded-pill shadow-xs"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label class="modal-label-premium">Conta para Deposito / Cobranca</label>
            <b-form-select
              v-model="boleto.contaId"
              :options="contasOpcoes"
              :state="!!boleto.contaId"
              class="rounded-pill shadow-xs"
            >
              <template slot="first">
                <option :value="null">-- Selecione a conta bancaria --</option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
      </div>

      <div class="modal-section-title mb-3">
        <i class="fa fa-money mr-2 text-primary"></i> Resumo de Saldos
      </div>

      <b-row>
        <b-col md="4">
          <div class="p-3 bg-white rounded border shadow-xs text-center h-100">
            <small class="modal-label-premium">Vlr. Original</small>
            <h5 class="mb-0 font-weight-bold text-dark">{{ formatCurrency(boleto.valorDocumento) }}</h5>
          </div>
        </b-col>
        <b-col md="4">
          <div class="p-3 bg-white rounded border shadow-xs text-center h-100">
            <small class="modal-label-premium">Recebimentos</small>
            <h5 class="mb-0 font-weight-bold text-info">{{ formatCurrency(boleto.valorRecebimentos) }}</h5>
          </div>
        </b-col>
        <b-col md="4">
          <div class="p-3 bg-white rounded border shadow-sm text-center h-100 border-success border-2">
            <small class="modal-label-premium text-success">Vlr. a Gerar</small>
            <h4 class="mb-0 font-weight-bold text-success">{{ formatCurrency(boleto.valorRestante) }}</h4>
          </div>
        </b-col>
      </b-row>
    </div>

    <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
      <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="fechar()">
        CANCELAR
      </b-button>
      <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="gerarBoleto()" :disabled="!podeConfirmarGeracaoBoleto">
        <i class="fa fa-barcode mr-1"></i> GERAR BOLETO AGORA
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import Tools from '@/tools/tools.js'

export default {
  data() {
    return {
      contasOpcoes: [],
      empresas: {
        items: [],
        options: [{ value: null, text: '' }]
      },
      boleto: {
        empresaId: null,
        contaId: null,
        vendaId: null,
        SITUACAO: null,
        boletoId: null,
        documento: null,
        parcela: null,
        nomeCliente: null,
        clienteId: null,
        valorRecebimentos: 0,
        valorMulta: 0,
        valorDesconto: 0,
        valorDocumento: 0,
        valorRestante: 0,
        valorAberto: 0
      }
    }
  },
  computed: {
    podeConfirmarGeracaoBoleto() {
      return this.isVendaFechada(this.boleto) && !!this.boleto.empresaId && !!this.boleto.contaId
    }
  },
  methods: {
    isVendaFechada(item) {
      return String((item && item.SITUACAO) || '').trim() === '1'
    },
    podeGerarBoleto(item) {
      const statusBoleto = String(item && item.OP_STATUS_BOLETO_EMITIDO != null ? item.OP_STATUS_BOLETO_EMITIDO : '').trim()
      return this.isVendaFechada(item) && ['0', '1', ''].includes(statusBoleto)
    },
    async abrir(item) {
      if (!this.podeGerarBoleto(item)) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Boleto permitido apenas para venda fechada.')
        return
      }

      this.boleto.vendaId = item.SEQUENCIA
      this.boleto.documento = item.SEQUENCIA
      this.boleto.clienteId = item.COD_CLI
      this.boleto.empresaId = 1
      this.boleto.SITUACAO = item.SITUACAO
      this.boleto.nomeCliente = item.NOME_CLIENTE
      this.boleto.contaId = null
      this.boleto.valorRecebimentos = 0
      this.boleto.valorMulta = 0
      this.boleto.valorDesconto = 0
      this.boleto.valorAberto = item.VL_TOTAL_NFE
      this.boleto.valorDocumento = item.VL_TOTAL_NFE
      this.boleto.valorRestante = (Number(item.VL_TOTAL_NFE) || 0) - (Number(this.boleto.valorRecebimentos) || 0)

      this.$store.commit('venda/SET_REGISTRO_SELECIONADO_ID', item.SEQUENCIA)
      try {
        this.$store.commit('controle/setAguardando', true)
        await this.carregarEmpresas()
        await this.carregarContas()
        this.$refs.modal.show()
      } catch (err) {
        console.error(err)
        Tools.exibirMensagem(this.$store, 'Operacao Indisponivel', 'danger', err)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    fechar() {
      this.$refs.modal.hide()
    },
    async gerarBoleto() {
      if (!this.isVendaFechada(this.boleto)) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Boleto permitido apenas para venda fechada.')
        return
      }

      if (!this.boleto.contaId) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Selecione a conta bancária para emitir o boleto.')
        return
      }

      if (!this.boleto.empresaId) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Informe os dados Obrigatorios.')
        return
      }

      const bodyBoleto = {
        vendaId: this.boleto.vendaId,
        bancoContaId: this.boleto.contaId,
        empresaId: this.boleto.empresaId,
        valorRestante: this.boleto.valorRestante
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        const resultado = await this.$http.post('/api/protected/boleto/postByVenda', bodyBoleto)
        await this.$store.dispatch('venda/GERAR_LISTA')
        this.$emit('atualizar')

        const boletoGerado = resultado?.data ?? null
        if (!boletoGerado || !boletoGerado.boletosIds || boletoGerado.boletosIds.length === 0) {
          Tools.exibirMensagem(this.$store, 'Boleto', 'warning', 'Nao foi possivel gerar o Boleto!')
          return
        }

        const boletoIds = boletoGerado.boletosIds
          .map(id => Number(id))
          .filter(id => id > 0)

        const gerarResponse = await this.$http.post('/api/protected/integrador/gerarBoleto', {
          contaId: this.boleto.contaId,
          boletoId: boletoIds[0],
          boletoIds
        })
        const boletoPDF = gerarResponse?.data ?? null
        if (!boletoPDF || !boletoPDF.sucesso || !boletoPDF.pdfBase64) {
          const erro = gerarResponse?.erro || 'Nao foi possivel baixar o PDF do Boleto.'
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', erro)
          return
        }

        const byteCharacters = atob(boletoPDF.pdfBase64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        window.open(window.URL.createObjectURL(blob))
        this.fechar()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err)
        console.error('Erro ao gerar boleto:', err)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return 'R$ 0,00'
      const numericValue = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value
      if (isNaN(numericValue)) return 'R$ 0,00'
      return numericValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    async carregarEmpresas() {
      this.empresas.items = []
      this.empresas.options = []
      const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/empresa/getTodas'))
      const empresasArray = [].concat(response?.data || [])
      for (let emp of empresasArray) {
        this.empresas.options.push({ value: emp.CODIGO, text: `${emp.APELIDO} - ${emp.IE} - ${emp.RAZAO}` })
      }
    },
    async carregarContas() {
      this.contasOpcoes = []
      this.boleto.contaId = null
      const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/conta/listarAtivasBoleto'))
      if (response && response.data) {
        for (let conta of response.data) {
          this.contasOpcoes.push({ value: conta.ID, text: conta.CODIGONOME })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/movimentos/vendas/components/VendaBoletoModal.vue